import producer from 'immer';
import { Reducer } from 'redux';
import { AuthTypes } from '../auth/types';
import { AppControllersState, AppControllersTypes } from './types';

const INITIAL_STATE: AppControllersState = {
  emailSelected: undefined,
  authenticationStep: 1,
};

const reducer: Reducer<AppControllersState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case AuthTypes.PRE_SIGN_IN_SUCCESS:
      return producer(state, draft => {
        draft.authenticationStep = 2;
      });

    case AuthTypes.REQUEST_PWD_SIGN_IN_SUCCESS:
      return producer(state, draft => {
        draft.authenticationStep = 3;
      });

    case AppControllersTypes.SELECT_EMAIL:
      return producer(state, draft => {
        draft.emailSelected = action.payload.emailSelected;
      });

    default:
      return state;
  }
};

export default reducer;
